// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9eb00ecb","718":"6d4d0e68","898":"98787764"}[chunkId] + ".chunk.js";
};